
import { Card } from "@/components/ui/card";
import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";

interface FeedItem {
  id: string;
  created_at: string;
  type: string;
  data: any;
  read: boolean;
}

export const FeedCard = () => {
  const [feedItems, setFeedItems] = useState<FeedItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFeedItems = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return;

      const { data, error } = await supabase
        .from('feed_items')
        .select('*')
        .eq('user_id', user.id)
        .order('created_at', { ascending: false })
        .limit(5);

      if (error) {
        console.error('Error fetching feed items:', error);
      } else {
        setFeedItems(data || []);
      }
      setLoading(false);
    };

    fetchFeedItems();
  }, []);

  const renderFeedItem = (item: FeedItem) => {
    switch (item.type) {
      case 'tip':
        return (
          <div key={item.id} className="p-4 border-b last:border-b-0">
            <p className="text-sm">
              <span className="font-semibold">{item.data.from}</span> tipped you ${item.data.amount}
            </p>
            <p className="text-xs text-muted-foreground">
              {new Date(item.created_at).toLocaleDateString()}
            </p>
          </div>
        );
      case 'platform_update':
        return (
          <div key={item.id} className="p-4 border-b last:border-b-0">
            <p className="text-sm font-semibold">{item.data.title}</p>
            <p className="text-sm">{item.data.message}</p>
            <p className="text-xs text-muted-foreground">
              {new Date(item.created_at).toLocaleDateString()}
            </p>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <Card className="col-span-2">
      <div className="p-6">
        <h2 className="text-xl font-semibold mb-4">Activity Feed</h2>
        <div className="divide-y">
          {loading ? (
            <p className="text-muted-foreground text-sm">Loading feed...</p>
          ) : feedItems.length > 0 ? (
            feedItems.map(renderFeedItem)
          ) : (
            <p className="text-muted-foreground text-sm">No recent activity</p>
          )}
        </div>
      </div>
    </Card>
  );
};
